function ProgramBenefits() {
  return (
    <section className="about-features-section">
      <div className="container">
        <div className="about-features-header">
          <span className="section-badge reveal visible">PROGRAM BENEFITS</span>
          <h2 className="section-title reveal visible">Everything You Get</h2>
          <p className="section-desc reveal visible">
            Our program is packed with benefits designed to fast-track your tech
            career.
          </p>
        </div>

        <div className="about-features-grid">
          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            <h3>Expert Mentorship</h3>
            <p>
              Learn directly from experienced engineers with real industry
              experience across multiple tech domains.
            </p>
          </div>

          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-graduation-cap"></i>
            </div>
            <h3>Lifetime Udemy Course</h3>
            <p>
              Get a premium Udemy course for your track — yours to keep forever,
              even after the program ends.
            </p>
          </div>

          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-certificate"></i>
            </div>
            <h3>3 Certificates</h3>
            <p>
              Receive a Training Certificate, Internship Certificate, and
              Experience Letter upon program completion.
            </p>
          </div>

          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-project-diagram"></i>
            </div>
            <h3>Real-World Projects</h3>
            <p>
              Work on live, industry-grade projects that go straight into your
              portfolio for employers to see.
            </p>
          </div>

          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-headset"></i>
            </div>
            <h3>24/7 Mentor Support</h3>
            <p>
              Got stuck at midnight? Our mentors are available around the clock
              to help you push through.
            </p>
          </div>

          <div className="about-feature-card reveal visible">
            <div className="about-feature-icon">
              <i className="fas fa-briefcase"></i>
            </div>
            <h3>Job Placement Support</h3>
            <p>
              Resume building, mock interviews, letter of recommendation, and
              direct job opportunities after completion.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProgramBenefits;
